import { FC, useEffect } from 'react'
import { Button, Card, Empty, Spin, Tag } from 'antd'
import {
	ArrowLeftOutlined,
	FileTextOutlined,
	PlayCircleOutlined
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { learningStore } from '../store/learning'
import { authStore } from '../store/auth'
import { RNLearning } from '../helpers/routeNames'
import { PageBreadcrumb } from '../components/PageBreadcrumb'

export const LearningFavorites: FC = () => {
	const navigate = useNavigate()
	const { isLoggedIn } = authStore()
	const { userPins, loading, fetchUserPins } = learningStore()

	useEffect(() => {
		if (isLoggedIn) {
			fetchUserPins()
		}
	}, [isLoggedIn, fetchUserPins])

	if (!isLoggedIn) {
		return (
			<div
				style={{
					padding: 16,
					textAlign: 'center',
					paddingTop: 60
				}}>
				<Empty description="Войдите в систему, чтобы увидеть избранное" />
			</div>
		)
	}

	return (
		<div style={{ padding: '16px', paddingBottom: '90px' }}>
			<PageBreadcrumb
				items={[
					{ label: 'База знаний', path: RNLearning },
					{ label: 'Избранное' }
				]}
			/>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 12,
					marginBottom: 16
				}}>
				<Button
					icon={<ArrowLeftOutlined />}
					onClick={() => navigate(RNLearning)}>
					Назад
				</Button>
				<h1 style={{ margin: 0 }}>Избранное</h1>
			</div>

			{loading ? (
				<div style={{ textAlign: 'center', padding: 60 }}>
					<Spin size="large" />
				</div>
			) : userPins.length === 0 ? (
				<Empty description="У вас пока нет избранных материалов" />
			) : (
				<div
					style={{
						display: 'grid',
						gridTemplateColumns:
							'repeat(auto-fill, minmax(280px, 1fr))',
						gap: 16
					}}>
					{userPins.map((m) => (
						<Card
							key={m.id}
							hoverable
							onClick={() =>
								navigate(
									`${RNLearning}/${m.id}`
								)
							}
							styles={{ body: { padding: 16 } }}>
							<h3
								style={{
									margin: '0 0 8px',
									fontSize: 16
								}}>
								{m.title}
							</h3>
							{m.description && (
								<p
									style={{
										margin: '0 0 12px',
										color: '#666',
										fontSize: 13,
										display: '-webkit-box',
										WebkitLineClamp: 2,
										WebkitBoxOrient:
											'vertical',
										overflow: 'hidden'
									}}>
									{m.description}
								</p>
							)}
							<div
								style={{
									display: 'flex',
									gap: 6,
									flexWrap: 'wrap'
								}}>
								<Tag color="blue">
									{m.category}
								</Tag>
								{!!m.pdfCount && (
									<Tag
										icon={
											<FileTextOutlined />
										}>
										{m.pdfCount} PDF
									</Tag>
								)}
								{!!m.videoCount && (
									<Tag
										icon={
											<PlayCircleOutlined />
										}>
										{m.videoCount} видео
									</Tag>
								)}
							</div>
						</Card>
					))}
				</div>
			)}
		</div>
	)
}
